/**
 * created on: 2019.05.09
 * 广播管理左侧导航
 */
"use strict"
angular.module('broadcastManageLeftModule', [])
    .directive('broadcastManageLeft', ['$q', 'trsHttpService', '$state', '$stateParams', function($q, trsHttpService, $state, $stateParams) {
        return {
            restirct: "A",
            scope: true,
            replace: false,
            templateUrl: "./manageConfig/productManageMent/broadcast/left/left_tpl.html",
            link: function($scope, $element, $attrs) {
                initStatus();
                initData();

                function initStatus() {
                    $scope.status = {
                        selectedStation: $stateParams.siteid,
                    };
                    $scope.data = {
                        tvStation: [],
                    };
                }

                function initData() {
                    getAllStation();
                }
                /**
                 * [getAllStation 获取所有站点数据]
                 * @return {[type]} [description]
                 */
                function getAllStation() {
                    var params = {
                        serviceid: 'mlf_broadcastconfig',
                        methodname: 'queryBroadcastSitesForCloud'
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        if (angular.isArray(data)) {
                            $scope.data.tvStation = data;
                        } else {
                            $scope.data.tvStation = data.DATA;
                        }
                    });
                }

                /**
                 * [selectedStation 选择电视台站点]
                 * @param  {[type]} station [description]
                 * @return {[type]}         [description]
                 */
                $scope.selectedStation = function(station) {
                    if ($scope.status.selectedStation == station.SITEID) return;
                    $scope.status.selectedStation = station.SITEID;
                    var router = 'manageconfig.productmanage.broadcast.manage';
                    $state.go(router, { siteid: station.SITEID });
                };


            }
        };
    }]);